<mifosx-entity-notes-tab [entityId]="entityId"
  [entityNotes]="entityNotes"
  [callbackAdd]="addNote"
  [callbackEdit]="editNote"
  [callbackDelete]="deleteNote"
>
</mifosx-entity-notes-tab>
